/**
 * @since 2.0.0
 */
import * as _RequestBlock from "./internal/blockedRequests.js";
/**
 * @since 2.0.0
 * @category constructors
 */
export const single = _RequestBlock.single;
/**
 * @since 2.0.0
 * @category constructors
 */
export const empty = _RequestBlock.empty;
/**
 * @since 2.0.0
 * @category constructors
 */
export const mapRequestResolvers = _RequestBlock.mapRequestResolvers;
/**
 * @since 2.0.0
 * @category constructors
 */
export const parallel = _RequestBlock.par;
/**
 * @since 2.0.0
 * @category constructors
 */
export const reduce = _RequestBlock.reduce;
/**
 * @since 2.0.0
 * @category constructors
 */
export const sequential = _RequestBlock.seq;
//# sourceMappingURL=RequestBlock.js.map